import { queryOptions } from "@tanstack/react-query";
import { $getDuplicateGroupDetail, $getDuplicateGroups } from "./functions";

export const duplicateGroupsQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "duplicates", "groups"],
    queryFn: ({ signal }) => $getDuplicateGroups({ signal, data: { projectId } }),
    // Groups change during review, always refetch
    staleTime: 0,
  });

export const duplicateGroupDetailQueryOptions = (projectId: string, groupId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "duplicates", "groups", groupId],
    queryFn: ({ signal }) =>
      $getDuplicateGroupDetail({ signal, data: { projectId, groupId } }),
  });
